// extracted by mini-css-extract-plugin
export default {"error":"style_error__kxk+N"};